<div class="m-form-field">
  <div class="a-text-field tw-flex">
    <div class="tw-flex empty:tw-hidden">
      <ng-content select="[prefix]"></ng-content>
    </div>

    <div class="tw-w-full">
      @if(label){
      <label [for]="id"> {{ label }} @if(isRequired$ | async){ * } </label>
      }

      <input
        [id]="id"
        [formControl]="control"
        [placeholder]="placeholder"
        [readonly]="readonly"
        [disabledControl]="isDisabled$ | async"
        [boschUiInputAutofocus]="autofocus"
        type="text"
      />
    </div>

    <div class="tw-flex empty:tw-hidden">
      <ng-content select="[postfix]"></ng-content>
    </div>
  </div>

  @if (!errorRef && (error$ | async); as error) {
  <bosch-ui-validation-error [error]="'common.validation.error.' + error | translate"></bosch-ui-validation-error>
  } @if (errorRef) {
  <ng-content></ng-content>
  }
</div>
